import type { CpmState } from '../../../types/centralProductMaster.types';
import type { ConfigTemplateLicenceType } from '../../../types/configTemplate.types';
import { catalogStateName } from './stateCatalog';

export function licenceLabel(item: ConfigTemplateLicenceType, states: CpmState[]): string {
    const state = states.find((row) => catalogStateName(row) === item.state);
    const match = state?.licenseTypes?.find((type) => type.code === item.code);
    return match?.label ?? item.code;
}

export function licenceKey(item: ConfigTemplateLicenceType): string {
    return `${item.state}::${item.code}`;
}

export function parseLicenceKey(key: string): ConfigTemplateLicenceType | null {
    const idx = key.indexOf('::');
    if (idx <= 0) return null;
    return { state: key.slice(0, idx), code: key.slice(idx + 2) };
}
